import { gql } from "apollo-boost";

const users = gql`
  query users($filter: UserFilter) {
    users(filter: $filter) {
      total
      items {
        id
        name
        email
        mobile
        state
        role
        profile {
          idStatus
        }
        chooseCommunity {
          id
          name
        }
        invited {
          code
          userId
          userName
        }
        sexOffender {
          state
        }
        lastActivity
        createDate
        appRate
        userRate
        poolInfo {
          lastModifiedDate
          enabled
          status
        }
      }
    }
  }
`;

const shareEduOfferUsers = gql`
  query users($filter: UserFilter) {
    users(filter: $filter) {
      total
      items {
        id
        name
        email
        state
        lastActivity
        createDate
      }
    }
  }
`;

const findUserByEmail = gql`
  query findUserByEmail($email: String!) {
    findUserByEmail(email: $email) {
      id
      name
      title
      firstName
      lastName
      mobile
      email
    }
  }
`;

const findUserByEmailWithChildren = gql`
  query findUserByEmail($email: String!) {
    findUserByEmail(email: $email) {
      id
      name
      title
      firstName
      lastName
      mobile
      email
      children {
        childId
        name
        schoolId
        school {
          id
          name
        }
        grade
      }
    }
  }
`;

const user = gql`
  query user($id: String!) {
    user(id: $id) {
      id
      name
      title
      firstName
      lastName
      mobile
      email
      role
      isTeacher
      lastActivity
      divisionId
      division {
        id
        name
        region {
          id
          name
        }
      }
      orgIds
      orgs {
        id
        name
      }
      children {
        childId
        name
        interests
        schoolId
        grade
      }
      poolInfo {
        lastModifiedDate
        enabled
        status
      }
    }
  }
`;

const userVerification = gql`
  query user($id: String!) {
    user(id: $id) {
      id
      name
      verifications {
        id
        userId
        createDate
        type
        status
      }
      profile {
        location {
          addr
        }
      }
    }
  }
`;

const userVerifications = gql`
  query userVerifications($filter: IdVerificationFilter) {
    userVerifications(filter: $filter) {
      total
      items {
        id
        userId
        createDate
        firstTime
        type
        status
        frontUrl
        backUrl
        videoUrl
        videoImage
        firstName
        lastName
        reason
        notes
        reviewDate
        expirationDate
        user {
          name
        }
      }
    }
  }
`;

const confirmIdVerification = gql`
  mutation confirmIdVerification($input: ConfirmIdVerificationInput!) {
    confirmIdVerification(input: $input)
  }
`;

const verifiedUserVerification = gql`
  mutation verifiedUserVerification($id: String!) {
    verifiedUserVerification(id: $id)
  }
`;

export const resetIdStatus = gql`
  mutation resetIdStatus($userId: String!) {
    resetIdStatus(userId: $userId)
  }
`;

export const resetDlStatus = gql`
  mutation resetDlStatus($userId: String!) {
    resetDlStatus(userId: $userId)
  }
`;

const createUser = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input)
  }
`;

const createFamily = gql`
  mutation createFamily($input: CreateFamilyInput!) {
    createFamily(input: $input)
  }
`;

export const AddUser = gql`
  mutation addUser($input: AddUserInput!) {
    addUser(input: $input)
  }
`;

const saveUser = gql`
  mutation saveUser($input: UpdateUserInput!) {
    saveUser(input: $input)
  }
`;

const setUserChooseCommunity = gql`
  mutation setUserChooseCommunity($userId: String!, $communityId: String!) {
    setUserChooseCommunity(userId: $userId, communityId: $communityId)
  }
`;

const setShareEduOffer = gql`
  mutation setShareEduOffer($email: String!) {
    setShareEduOffer(email: $email)
  }
`;

const updateUserIsShareEduOffer = gql`
  mutation updateUserIsShareEduOffer($userId: String!, $isShareEduOffer: Boolean!) {
    updateUserIsShareEduOffer(userId: $userId, isShareEduOffer: $isShareEduOffer)
  }
`;

export const ResendUser = gql`
  mutation resendUser($id: String!) {
    resendUser(id: $id)
  }
`;

export const DelUser = gql`
  mutation delUser($id: String!) {
    delUser(id: $id)
  }
`;

export const userGql = {
  users,
  user,
  createUser,
  saveUser,
  createFamily,
  findUserByEmail,
  findUserByEmailWithChildren,
  userVerification,
  userVerifications,
  verifiedUserVerification,
  resetIdStatus,
  resetDlStatus,
  setUserChooseCommunity,
  confirmIdVerification,
  shareEduOfferUsers,
  setShareEduOffer,
  updateUserIsShareEduOffer,
};
